<template>
    <div class="agentContent">
        <div class="transportTitle">
            {{$translate('lang.E3202103030011', { defaultText: '渠道销售' })}}
            <span class="line"></span>
        </div>
        <div class="content">
            <div class="sideBar">
                <div v-for="(item,index) in list" :key= 'index + "icon"'>
                    <div class="sideBarContent" :style='"top:" + 134*index + "px"'>
                        <div class='iconShow' ref='svgShow'>
                            <span class='icon font_family'>{{item.icon}}</span>
                        </div>
                    </div>
                    <div class="columnLine" :style='"top:" + (29 + 135*index) + "px"'>
                    </div>
                </div>
                <div class='sideBarContent' :style='"top:" + (134 * listLength) + "px"'>
                    <div class='iconShow' ref='svgShow'>
                        <span class='icon font_family'>&#xe6a9;</span>
                    </div>
                </div>
            </div>
            <div class="main">
                <div class="mainContent" v-for="(item2, index) in list" :key='index'>
                    <div class="iconText">{{item2.label}}</div>
                    <el-row class="commomPaper itemMain">
                        <el-col :span='item.span' class="itemRow" v-for="(item,index) in item2.makeList" :key='index'>
                            <div class="labelText" :title='item.label'>{{item.label}}</div>
                            <el-tooltip effect="dark" :content='item.value' placement="top" v-if='item["value"].length > 34'>
                                <span class="valueText unitValueText">{{item.value}}</span>
                            </el-tooltip>
                            <div class="valueText" v-else>{{item.value}}</div>
                        </el-col>
                    </el-row>
                </div>
                <div class="mainContent">
                    <div class="iconText">{{$translate('lang.E3202103030036', { defaultText: '开始' })}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { searchProAgent } from '../../../../api/productProcess.js';
export default {
    props: {
    },
    data () {
        return {
            proNum: '',
            flag: false,
            barArr: {},
            list: [],
            listLength: 0
        };
    },
    methods: {
        handleClick(tab, event) {
        },
        initbarArr() {
            this.barArr = {
                label: '',
                icon: '',
                makeList: [{
                    span: 8,
                    label: this.$translate('lang.E3202103030039', { defaultText: '商品编号' }),
                    value: '',
                    key: 'itemCode'
                }, {
                    span: 8,
                    label: this.$translate('lang.E3202103030040', { defaultText: '商品名称' }),
                    value: '',
                    key: 'itemName'
                }, {
                    span: 8,
                    label: this.$translate('lang.E3202103030041', { defaultText: '仓库' }),
                    value: '',
                    key: 'warehouseName'
                }, {
                    span: 8,
                    label: this.$translate('lang.E3202103030042', { defaultText: '单据号' }),
                    value: '',
                    key: 'sourceNo'
                }, {
                    span: 8,
                    label: this.$translate('lang.E3202103030043', { defaultText: '客户名称' }),
                    value: '',
                    key: 'customerName'
                }, {
                    span: 8,
                    label: this.$translate('lang.E3202103030044', { defaultText: '扫描时间' }),
                    value: '',
                    key: 'creationDate'
                }]
            };
        },
        initData() {
            this.list = [];
            this.listLength = 0;
        },
        setproNum(proNum) {
            this.initData();
            this.proNum = proNum;
            this.flag = true;
        },
        // 获取客户详细信息
        getMessage() {
            if (this.flag) {
                searchProAgent(this.proNum).then(res => {
                    if (res.code === '0' && res.data) {
                        const arr = res.data;
                        arr.forEach((item, index) => {
                            this.initbarArr();
                            const itemArr = Object.keys(item);
                            if (item['invBilltype'] === '入库') {
                                this.barArr['icon'] = '\ue6ab';
                                this.barArr['label'] = this.$translate('lang.E3202103030037', { defaultText: '入库' });
                            } else {
                                this.barArr['icon'] = '\ue6aa';
                                this.barArr['label'] = this.$translate('lang.E3202103030038', { defaultText: '出库' });
                            }
                            itemArr.map(item2 => {
                                this.barArr.makeList.forEach(item3 => {
                                    if (item3.key === item2) {
                                        item3.value = item[item2];
                                    }
                                });
                                return item2;
                            });
                            this.list.push(this.barArr);
                        });
                        this.listLength = this.list.length;
                    }
                    this.flag = false;
                });
            }
        }
    }
};
</script>
<style lang="less">
.agentContent {
    .transportTitle {
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #E4E7ED;
        margin-bottom: 15px;
        font-weight: 700;
        color: #333;
    }
    .content {
        position: relative;
        overflow: auto;
        max-height: calc(100vh - 370px);
        .sideBar {
            width: 80px;
        }
        .main {
            .itemMain {
                padding: 5px 15px;
                margin-top: 10px;
            }
            .mainContent {
                margin-bottom: 18px;
            }
        }
    }
    .sideBar{
        position: absolute;
        top: 10px;
        left: 0px;
        .columnLine {
            position: absolute;
            left: 13px;
            width: 0px;
            top: 29px;
            height: 101px;
            border: 1px dashed #e8e8e8;
        }
        .sideBarContent {
            position: absolute;
            top: 0px;
            left: 0px;
        }
        .iconShow {
            background-color: #4285f5;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            position: relative;
            .icon {
                font-size: 14px;
                position: absolute;
                top: 7px;
                left: 7px;
                color: #fff;
            }
        }
    }
    .main {
        padding: 16px 0 0 40px;
        box-sizing: border-box;
    }
    .iconText {
        font-size: 12px;
    }
    .jumpOut {
        color: #4285f5 !important;
        text-decoration: underline;
        cursor: pointer;
    }
}
</style>